import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { DossierAnalytics } from "./DossierAnalytics";

const EXPLANATIONS = [
  { label: "CONTROVERSY", color: "#8E2A26",
    text: "How intensely public narrative and official accounts conflict on this case." },
  { label: "EVIDENCE", color: "#28477A",
    text: "Strength of the documented evidence trail — primary documents, records and testimony." },
  { label: "SOURCE QUALITY", color: "#2E5D34",
    text: "Reliability of the cited sources, weighted toward academic, governmental and archival material." },
  { label: "CONSENSUS", color: "#463A6E",
    text: "Degree of agreement across credible sources. A low score means the record is still disputed." },
];

export const FullAssessmentDialog = ({ open, onOpenChange, topic }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      className="bg-[#14120E] border-[#454038] max-w-lg max-h-[85vh] overflow-y-auto"
      data-testid="full-assessment-dialog"
    >
      <DialogHeader>
        <DialogTitle className="font-mono text-xs uppercase tracking-[0.3em] text-[#D92D20]">
          // FULL EVIDENCE ASSESSMENT
        </DialogTitle>
        <DialogDescription className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#757065]">
          REF: {topic?.slug}
        </DialogDescription>
      </DialogHeader>

      {/* Assessment sheet — rendered on manila card stock so the
          hand-inked meters keep their archival look */}
      <div className="bg-[#cfba8b] p-4 sm:p-5 border border-[#8c7345]/50">
        <DossierAnalytics topic={topic} />
      </div>

      <div className="space-y-3 mt-1" data-testid="assessment-explanations">
        {EXPLANATIONS.map((e) => (
          <div key={e.label}>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] mb-0.5" style={{ color: e.color, filter: "brightness(1.7)" }}>
              // {e.label}
            </div>
            <p className="text-sm text-[#A39E93] leading-relaxed">{e.text}</p>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

export default FullAssessmentDialog;
